import React, { Dispatch, SetStateAction } from 'react'
import { useForm } from 'react-hook-form'
import { ComentarioFields, ComentarioPostFields } from '../types'
import { z } from 'src/lib'
import { zodResolver } from '@hookform/resolvers/zod'
import { Dialog, DialogTitle, DialogContent, Grid, DialogActions, Button } from '@mui/material'
import { AsyncSelect, ControlledTextField } from 'src/components/forms'
import toast from 'react-hot-toast'
import { HttpSistema } from '../api/httpSistema'

const schemaNuevoComentario = z.object({
    [ComentarioPostFields.CodComentarioTipo]: z.number(),
    [ComentarioPostFields.Comentario]: z.string()
})

type SchemaNuevoComentario = z.infer<typeof schemaNuevoComentario>

type DialogNuevoComentarioProps = {
    open: boolean
    setOpen: Dispatch<SetStateAction<boolean>>
    idOperacion: number
    codSistema: number
}

export const DialogNuevoComentario = ({ open, setOpen, idOperacion, codSistema }: DialogNuevoComentarioProps) => {

    const { control, handleSubmit } = useForm<SchemaNuevoComentario>({
        resolver: zodResolver(schemaNuevoComentario)
    })

    const alGuardarComentario = (data: SchemaNuevoComentario) => {
        const promise = HttpSistema.postComentario(codSistema, idOperacion, data)

        toast.promise(promise, {
            loading: 'Guardando',
            success: 'Guardado correctamente',
            error: 'Error al guardar'
        }).then(() => setOpen(false))
    }

    return (
        <Dialog open={open} maxWidth='sm' fullWidth>
            <DialogTitle>Nuevo comentario</DialogTitle>
            <DialogContent>
                <Grid container spacing={4} pt={2}>
                    <Grid item xs={12}>
                        <AsyncSelect
                            control={control}
                            name={ComentarioPostFields.CodComentarioTipo}
                            label='Tipo de comentario'
                            loadOptions={() => HttpSistema.getComentariosTipos()}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <ControlledTextField
                            control={control}
                            name={ComentarioPostFields.Comentario}
                            label='Comentario'
                            multiline
                            rows={3}
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant='text' color='primary' onClick={() => setOpen(false)}>
                    Cancelar
                </Button>
                <Button variant='contained' color='primary' onClick={handleSubmit(alGuardarComentario)}>
                    Guardar
                </Button>
            </DialogActions>
        </Dialog >
    )
}
